import React, { useState, useEffect } from 'react';

import { func, arrayOf, shape } from 'prop-types';

import AlphaLastNameInput from 'components/Common/Filter/AlphaLastNameFilter/components/AlphaLastNameInput';

import s from './AlphaLastNameFilter.css';

const AlphaLastNameFilter = props => {
  const { toggleFilter, removeFilter, selectedFilters } = props;
  const filterData = (selectedFilters?.[0]?.label ?? '').split(',');

  const alphaMinInitialValue = filterData?.[0] ?? '';
  const alphaMaxInitialValue = filterData?.[1] ?? '';

  const [currentMinValue, setCurrentMinValue] = useState('');
  const [currentMaxValue, setCurrentMaxValue] = useState('');

  // Initialize State values only when filterData is populated
  useEffect(() => {
    const preDefinedFilters = filterData.length > 1;
    if (preDefinedFilters) {
      setCurrentMinValue(alphaMinInitialValue);
      setCurrentMaxValue(alphaMaxInitialValue);
    }
  }, [alphaMinInitialValue, alphaMaxInitialValue, selectedFilters, filterData]);

  const onMinUpdate = value => {
    setCurrentMinValue(value);
    const newFilterData = {
      group: 'alphaLastName',
      id: `${value},${currentMaxValue}`,
      source: 'alphaLastName',
      singleFilter: true,
    };
    toggleFilter(newFilterData);
    if (!value && !currentMaxValue) {
      removeFilter('alphaLastName');
    }
  };

  const onMaxUpdate = value => {
    setCurrentMaxValue(value);
    const newFilterData = {
      group: 'alphaLastName',
      id: `${currentMinValue},${value}`,
      source: 'alphaLastName',
      singleFilter: true,
    };
    toggleFilter(newFilterData);
    if (!currentMinValue && !value) {
      removeFilter('alphaLastName');
    }
  };

  return (
    <div className={s.root}>
      <div className={s.label}>
        Define a range of students by their last name.
      </div>
      <div className={s.inputsRow}>
        <AlphaLastNameInput
          onChange={onMinUpdate}
          maxValue={15}
          label="Alpha min"
          placeholder="aaa"
          initialValue={alphaMinInitialValue}
        />
        <AlphaLastNameInput
          onChange={onMaxUpdate}
          maxValue={15}
          label="Alpha max"
          placeholder="zzz"
          initialValue={alphaMaxInitialValue}
        />
      </div>
    </div>
  );
};

AlphaLastNameFilter.propTypes = {
  toggleFilter: func.isRequired,
  removeFilter: func.isRequired,
  selectedFilters: arrayOf(shape({})),
};

AlphaLastNameFilter.defaultProps = {
  selectedFilters: [],
};

export default AlphaLastNameFilter;
